import { whenDocumentReady } from '../../../../assets/frontend/js/helper/documentready';
import { nossFilter } from '../../../../assets/frontend/js/helper/filter';

whenDocumentReady(initModule);
function initModule() {
    nossFilter();
}